import { ListItem, ListItemText } from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

import { Cell } from '@/core/architecture'

export const NotificationBoxSkeleton: Cell = () => (
  <ListItem sx={{ px: 0, mx: 5, width: 'auto' }} divider>
    <ListItemText
      primary={
        <SkeletonText
          variant="medium"
          numberOfLine={2}
          sx={{ mt: 2 }}
          lastWidth="75%"
        />
      }
      secondary={<SkeletonText variant="small" width="25%" sx={{ mt: 2 }} />}
    />
  </ListItem>
)
